import { createContext, useCallback, useContext, useState } from 'react';

// Default value keeps components usable outside the provider (e.g. in isolated tests).
const NotificationContext = createContext({ notification: null, showNotification: () => {} });

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState(null);

    // A new object on every call, so showing the same message twice still triggers a toast.
    const showNotification = useCallback((message, appearance = 'danger') => {
        setNotification({ message, appearance });
    }, []);

    return (
        <NotificationContext.Provider value={{ notification, showNotification }}>
            {children}
        </NotificationContext.Provider>
    );
}

export const useNotification = () => useContext(NotificationContext);

export default NotificationContext;
